import { render } from "./DeveloperFormView.vue?vue&type=template&id=358c5a68&scoped=true"
import script from "./DeveloperFormView.vue?vue&type=script&lang=js"
export * from "./DeveloperFormView.vue?vue&type=script&lang=js"

import "./DeveloperFormView.vue?vue&type=style&index=0&id=358c5a68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358c5a68"]])

export default __exports__